import { render, staticRenderFns } from "./AppInputPrompt.vue?vue&type=template&id=4c128b81&scoped=true"
import script from "./AppInputPrompt.vue?vue&type=script&lang=js"
export * from "./AppInputPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c128b81",
  null
  
)

export default component.exports